export default {
    data: [],
    loading: false,
    success: false,
    error: false,
    willVisualize: {
        data: [],
        loading: false,
        success: false,
        error: false,
    },
};
